import React from 'react';
import './Exchange.css';
import {Link} from 'react-router-dom';
import TAC from '../../components/TandC';
import Logo from '../../components/assets/logo.png';
import { Container, Row,Col } from 'react-bootstrap';
import Trade from "../ExchangeTrade/Trade"
import BTCRate from '../../components/BTCRate';
function Exchange() {

    const year = new Date().getFullYear();

  return (
      <div className="container">
        <div className="d-flex justify-content-between w-100 row">
        <div className="bts-exchange-page-caption-section">
            <div className="bts-landing-left-menu px-0">
                <div className="bts-landing-page-caption-logo">
                <Link to="/">
                    <img src={Logo} alt=""/>
                </Link>
                </div>
            </div>        
        </div>
        <div className="d-flex align-items-center d-sm-none d-md-flex disappear">
            <BTCRate/>
        </div>
        <div className="d-flex align-items-center">
            <Link to="/login" className="blueText mr-3">Login</Link>
            <Link to="/register" className="blueText">Register</Link>        
        </div>
        </div>
        <div className="px-0">
        <div className="bts-exchange-page-caption-section row">
                <Col md={2} className="mx-0 px-0">
                    <div className="bts-placeholder  d-flex justify-content-center align-items-center">
                        G
                    </div>
                </Col>
                <Col md={9} className="mx-0 px-0">
                <div className="">
                  
                        <p className="bts-welcome-text mt-3">You are welcome, Guest</p>
                        </div>
                </Col>
            </div>
            <Row className="justify-content-center">
                <Col md={10}>
                        
                    <div className="pt-4">
                        <Trade/>       
                    </div>
                </Col>
            </Row>
        </div>
        <Container className="bts-exchange-footer px-5">
            <Row className="d-flex justify-content-between lightText">
                <section>
                    <span className="mail">Copyright  Bitmasta Inc.</span><br/>
                    <span className="mail">All Rights Reserved {year}</span>
                </section>
                <section>
                    <span className="">
                        <TAC />
                    </span>
                </section>
            </Row>
        </Container>
      </div>
  );
}

export default Exchange;
